import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchNotifications } from "../actions/notificationActions";

interface Notification {
  id: number;
  title: string;
  message: string;
  createdAt: string;
  read: boolean;
}

interface NotificationsState {
  items: Notification[];
  loading: boolean;
  error: string | null;
  page: number;
  hasMore: boolean;
}

const initialState: NotificationsState = {
  items: [],
  loading: false,
  error: null,
  page: 1,
  hasMore: true,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action: PayloadAction<Notification[]>) => {
        state.loading = false;
        state.items = action.payload;
        state.hasMore = action.payload.length > 0;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});


export default notificationsSlice.reducer;
